import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col gap-12px"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row row-start" }
const _hoisted_4 = { class: "col gap-04" }
const _hoisted_5 = { class: "row mtop-10" }
const _hoisted_6 = { class: "bg-modal w-maxC" }
const _hoisted_7 = { class: "row-top gap-10 flexwrap" }
const _hoisted_8 = { class: "flex-col" }
const _hoisted_9 = {
  key: 0,
  class: "pleft-30px flex-row gap-02"
}
const _hoisted_10 = { class: "txt-grey-64" }
const _hoisted_11 = { class: "txt-grey-64" }
const _hoisted_12 = {
  key: 0,
  class: "pleft-30px flex-row gap-02"
}
const _hoisted_13 = { class: "txt-grey-64" }
const _hoisted_14 = { class: "txt-grey-64" }
const _hoisted_15 = {
  key: 2,
  class: "pleft-30px mtop-04"
}
const _hoisted_16 = { class: "flex-col" }
const _hoisted_17 = {
  key: 0,
  class: "pleft-30px mtop-04"
}
const _hoisted_18 = { class: "row mtop-10" }
const _hoisted_19 = { class: "bg-modal w-maxC" }
const _hoisted_20 = { class: "row-top gap-10 flexwrap" }
const _hoisted_21 = { class: "col pleft-30px" }
const _hoisted_22 = { class: "row gap-02" }
const _hoisted_23 = {
  key: 0,
  class: "mtop-04"
}

import addressInput from "@/views/patientMain/dashbAdmin/person/addressInput.vue";
import emailInput from "@/views/patientMain/dashbAdmin/person/emailInput.vue"
import phoneInput from "@/views/patientMain/dashbAdmin/person/phoneInput.vue"
import personNameInput from "@/views/patientMain/dashbAdmin/person/personNameInput.vue"
import { GENDER_TERMS } from "@/functions/office"
import { PHONE_PREFIX_LIST, getFlagEmojiForCountry } from "@/functions/geo";

import { ref, computed } from 'vue'
import { useCurrentEntryStore } from '@/stores/currentEntry'
import officeapi from "@/api/officeapi"
import { useUiStore } from '@/stores/ui'
import { format } from "date-fns";

import EsDataCard from '@/components/esDataCard.vue';
import { useI18n } from "vue-i18n"
import gen from "@/functions/general.js";
import { getFlagEmojiForPrefix } from "@/functions/geo.js";
import { ApiError, Regex } from "@/models/share.model";
import { AddressPersonRequest, PersonApi, UpdateEmailPwrRequest, UpdatePersonWithRoleAddressRequest, UpdatePersonWithRoleEmailRequest, UpdatePersonWithRolePhoneRequest, UpdatePhonePwrRequest } from "@/apiGenerate/medserver";
import { toastError, toastSuccess } from "@/utils/toast-utils";
import { Button, useToast } from "primevue";
import { medServerApiConfig } from "@/config/medserver-api.config";
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'dashbPerson',
  emits: [
	'emailUpdated'
],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const uiStore = useUiStore()
const currentEntryStore = useCurrentEntryStore()
const toast = useToast();

const emits = __emit;

const personApi = new PersonApi(medServerApiConfig);

const dropd = ref("");
const isPersonModalOpen = ref<boolean>(false);

async function copyPhoneToPwr(phone) {
  const pwrCurrentId = pwr.value.personWithRoleId
  const personPhoneId = phone.personPhoneId
  await officeapi.copyPhoneToPwr(pwrCurrentId, personPhoneId)
  await currentEntryStore.reloadPatientOnly();
  dropd.value = ""
}

async function copyEmailToPwr(email) {
  const pwrCurrentId = pwr.value.personWithRoleId
  const personEmailId = email.personEmailId
  await officeapi.copyEmailToPwr(pwrCurrentId, personEmailId)
  await currentEntryStore.reloadPatientOnly();
  dropd.value = "";
  emits('emailUpdated');
}

async function copyAddressToPwr(address) {
  const pwrCurrentId = pwr.value.personWithRoleId
  const personAddressId = address.personAddressId
  await officeapi.copyAddressToPwr(pwrCurrentId, personAddressId)
  await currentEntryStore.reloadPatientOnly();
  dropd.value = ""
}

const pwr = computed(() => {
	const view = uiStore.adminDashBoardView
	if (view === "dashbRelative") {
		return currentEntryStore.modalPatient.relatives.find(pwr => pwr.personWithRoleId === uiStore.adminDashBoardItem)
	}
	// if (view === "dashbPatient")
	return currentEntryStore.modalPatient
})

const sortedPhones = computed(() => {
	return sortByPreferenceThenDate(pwr.value?.phones || [])
})

const sortedMails = computed(() => {
	return sortByPreferenceThenDate(pwr.value?.emails || [])
})

const sortedAddresses = computed(() => {
	return sortByPreferenceThenDate(pwr.value?.addresses || [])
})

function sortByPreferenceThenDate(array) {
	return array.sort((a, b) => {
		if (a.isPreferred && !b.isPreferred) return -1
		if (!a.isPreferred && b.isPreferred) return 1
		return new Date(a.created) - new Date(b.created)
	})
}

const pwrRelatives = computed(() => {
	const pwrPatient = currentEntryStore.modalPatient
	const pwrPatientId = currentEntryStore.modalPatient.personWithRoleId
	const pwrCurrentId = pwr.value.personWithRoleId
	return (pwrCurrentId === pwrPatientId)
		? [...pwrPatient.relatives]
		: [pwrPatient]

	// return [pwrPatient, ...pwrPatient.relatives]
	// 	.filter(pwr => pwr.personWithRoleId !== pwrCurrentId)
})

const relativeAddresses = computed(() => {
	return pwrRelatives.value.flatMap(pwr => createItemsToCopy(pwr, "addresses", "address"))
})

const relativePhones = computed(() => {
	return pwrRelatives.value.flatMap(pwr => createItemsToCopy(pwr, "phones", "phone"))
})

const relativeEmails = computed(() => {
	return pwrRelatives.value.flatMap(pwr => createItemsToCopy(pwr, "emails", "email"))
})

const langs = computed(() => {
	return currentEntryStore.modalPatient.languages.flatMap(lang => lang.languageIso).join(" ")
})

function createItemsToCopy(pwr, arrayItems, arrayItem) {
	const { personWithRoleId, firstName, lastName } = pwr
	const link = pwr.relation?.description ?? "patient"
	return pwr[arrayItems].map(item => ({
		personWithRoleId,
		firstName,
		lastName,
		link,
		[arrayItem]: item,
	}))
}

function sendEmail(email: string) {
  window.location.href = gen.getEmailUrl(email); 
}

function callNumber(phoneNumber: string, phonePrefix: string) {
  window.location.href = gen.getTelUrl(phoneNumber, phonePrefix);
}

function contact (rawNumber) {
  if (rawNumber === '') return rawNumber
  return rawNumber.match(/.{1,3}/g).join(' ')
}

function openMap(address) {
  const fullAddress = `${address.street}, ${address.postalCodePrefix || ''}${address.postalCode} ${address.locality}, ${address.country}`;
  const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`;
  window.open(url, "_blank");
}

const updateAddress = async (addressPersonRequest: AddressPersonRequest, addressId: string) => {
  if (addressPersonRequest && currentEntryStore.modalPatient && addressId) {
    const updatePersonWithRoleAddressRequest: UpdatePersonWithRoleAddressRequest = {
      personId: currentEntryStore.modalPatient.personWithRoleId,
      personAddressId: addressId,
      addressPersonRequest: addressPersonRequest
    }
    personApi.updatePersonWithRoleAddress(updatePersonWithRoleAddressRequest).then(async () => {
		await currentEntryStore.reloadPatientOnly();
		dropd.value = '';
		toastSuccess(toast, {
			summary: t('common.toast.success.update'),
			detail: t('settings.params.account.toast.update.address')
		});
    }).catch((error: ApiError) => {
		toastError(toast, {
			summary: t('common.toast.error'),
			detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
		});

		// Throw error to set at false the var __alreadyClicked in v-one-click directive
		throw error;
    });
  }
}

const updateEmail = async ( updateEmailPwrRequest: UpdateEmailPwrRequest, emailId: string) => {
  if (updateEmailPwrRequest && currentEntryStore.modalPatient && emailId) {
    const updatePersonWithRoleEmailRequest: UpdatePersonWithRoleEmailRequest = {
      emailId: emailId,
      personId: currentEntryStore.modalPatient.personWithRoleId,
      updateEmailPwrRequest: updateEmailPwrRequest
    };
    
    personApi.updatePersonWithRoleEmail(updatePersonWithRoleEmailRequest).then(async () => {
		await currentEntryStore.reloadPatientOnly();
		dropd.value = '';
		toastSuccess(toast, {
			summary: t('common.toast.success.update'),
			detail: t('settings.params.account.toast.update.email')
		});

		emits('emailUpdated');
    }).catch((error: ApiError) => {
		toastError(toast, {
			summary: t('common.toast.error'),
			detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
		});

		// Throw error to set at false the var __alreadyClicked in v-one-click directive
        throw error;
    });
  }
}

const updatePhone = async (updatePhonePwrRequest: UpdatePhonePwrRequest, phoneId: string) => {
  if (updatePhonePwrRequest && currentEntryStore.modalPatient && phoneId) {
    const updatePersonWithRolePhone: UpdatePersonWithRolePhoneRequest = {
      phoneId: phoneId,
      personId: currentEntryStore.modalPatient.personWithRoleId,
      updatePhonePwrRequest: updatePhonePwrRequest
    }

    personApi.updatePersonWithRolePhone(updatePersonWithRolePhone).then(async () => {
		await currentEntryStore.reloadPatientOnly();
		dropd.value = '';
		toastSuccess(toast, {
			summary: t('common.toast.success.update'),
			detail: t('settings.params.account.toast.update.phone')
		});
    }).catch((error: ApiError) => {
		toastError(toast, {
			summary: t('common.toast.error'),
			detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
		});

		// Throw error to set at false the var __alreadyClicked in v-one-click directive
		throw error;
    });
  }
}

const deleteEmail = async (emailId: string) => {
	if (emailId && currentEntryStore.modalPatient) {
		personApi.deletePersonWithRoleEmail({personId: currentEntryStore.modalPatient.personWithRoleId, emailId: emailId, isPatient: true}).then(async () => {
			await currentEntryStore.reloadPatientOnly();
			toastSuccess(toast, {
				summary: t('common.toast.success.delete'),
				detail: t('settings.params.account.toast.delete.email')
			});
			emits('emailUpdated');
		}).catch((error: ApiError) => {
			toastError(toast, {
				summary: t('common.toast.error'),
				detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
			});
		});
	}
}

const deletePhone = async (phoneId: string) => {
  if (phoneId && currentEntryStore.modalPatient) {
    personApi.deletePersonWithRolePhone({personId: currentEntryStore.modalPatient.personWithRoleId, phoneId: phoneId, isPatient: true}).then(async () => {
      await currentEntryStore.reloadPatientOnly();
      toastSuccess(toast, {
        summary: t('common.toast.success.delete'),
        detail: t('settings.params.account.toast.delete.phone')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    });
  }
}

const deleteAddress = async (addressId: string) => {
  if (addressId && currentEntryStore.modalPatient) {
   personApi.deletePersonWithRoleAddress({personId: currentEntryStore.modalPatient.personWithRoleId, personAddressId: addressId, isPatient: false}).then(async () => {
      await currentEntryStore.reloadPatientOnly();

      toastSuccess(toast, {
        summary: t('common.toast.success.delete'),
        detail: t('settings.params.account.toast.delete.address')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    });
  }
}

const createPhone = async (value: {phonePrefix: string, phoneNumber: number, phoneIsMobile: boolean, phoneNote: string}) => {
  if (currentEntryStore.modalPatient && value) {
    try {
      await officeapi.addPhoneToPwr(currentEntryStore.modalPatient.personWithRoleId, value.phonePrefix, value.phoneNumber, value.phoneIsMobile, value.phoneNote);
      await currentEntryStore.reloadPatientOnly();
      toastSuccess(toast, {
        summary: t('common.toast.success.add'),
        detail: t('settings.params.account.toast.add.phone')
      })
    } catch (error: ApiError) {
		toastError(toast, {
			summary: t('common.toast.error'),
			detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
		});

		// Throw error to set at false the var __alreadyClicked in v-one-click directive
		throw error;
    }
  }
}

const createEmail = async (value: {email: string, note: string}) => {
  if (currentEntryStore.modalPatient && value) {
    try {
		await officeapi.addEmailToPwr(currentEntryStore.modalPatient.personWithRoleId, value.email, value.note);
		await currentEntryStore.reloadPatientOnly();

		toastSuccess(toast, {
			summary: t('common.toast.success.add'),
			detail: t('settings.params.account.toast.add.email')
		});
		emits('emailUpdated');
    } catch (error: ApiError) {
		toastError(toast, {
			summary: t('common.toast.error'),
			detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
		});

		// Throw error to set at false the var __alreadyClicked in v-one-click directive
		throw error;
    }
  }
}

const createAddress = async (personAddress: AddressPersonRequest) => {
  if (currentEntryStore.modalPatient && personAddress) {
    personApi.createPersonWithRoleAddress({personId: currentEntryStore.modalPatient.personWithRoleId, isPatient: false, addressPersonRequest: personAddress})
      .then(async () => {
        await currentEntryStore.reloadPatientOnly();

        toastSuccess(toast, {
          summary: t('common.toast.success.add'),
          detail: t('settings.params.account.toast.add.address')
        });
      }).catch((error: ApiError) => {
        toastError(toast, {
          summary: t('common.toast.error'),
          detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });

		// Throw error to set at false the var __alreadyClicked in v-one-click directive
        throw error;
    });
  }
}

const openPersonModal = () => {
	isPersonModalOpen.value = true;
}

const closePersonModal = () => {
	isPersonModalOpen.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_list_group = _resolveComponent("list-group")!

  return (pwr.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.admin.subtitle.identityDetail'),
            class: "h4"
          }, null, 8, ["txt"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Button), {
            onClick: openPersonModal,
            variant: "text",
            class: "modal-btn"
          }, {
            default: _withCtx(() => [
              _createVNode(EsDataCard, {
                title: _unref(PersonService).formatName(pwr.value.lastName, pwr.value.firstName),
                icon: 'person_fill',
                folderIcon: 'shareIcons',
                ref: 'mail-' + 0,
                backgroundClass: "bg-blue-04"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.admin.birthday') + ' : ' +  _unref(format)(new Date(pwr.value?.birthDate), 'dd/MM/yyyy'),
                      class: "pleft-30px txt-grey-64"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.admin.gender') + ' : ' +  _unref(GENDER_TERMS)[pwr.value?.gender],
                      class: "pleft-30px txt-grey-64"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.admin.langs') + ' : ' +  langs.value,
                      class: "pleft-30px txt-grey-64"
                    }, null, 8, ["txt"])
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _: 1
          }),
          _createVNode(personNameInput, {
            person: pwr.value,
            "is-open": isPersonModalOpen.value,
            onClose: closePersonModal
          }, null, 8, ["person", "is-open"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.admin.subsubtitle.contact'),
            class: "h5"
          }, null, 8, ["txt"]),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dropd).value = $event)),
            openOn: "addNewFix"
          }, {
            dropd: _withCtx(() => [
              _createVNode(phoneInput, {
                pwr: pwr.value,
                newIsMobile: false,
                onClose: _cache[0] || (_cache[0] = ($event: any) => (dropd.value = '')),
                ownerType: "patient",
                onCreatePersonPhone: _cache[1] || (_cache[1] = ($event: any) => (createPhone($event)))
              }, null, 8, ["pwr"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dropd).value = $event)),
            openOn: "addNewMobile"
          }, {
            dropd: _withCtx(() => [
              _createVNode(phoneInput, {
                pwr: pwr.value,
                newIsMobile: true,
                onClose: _cache[3] || (_cache[3] = ($event: any) => (dropd.value = '')),
                ownerType: "patient",
                onCreatePersonPhone: _cache[4] || (_cache[4] = ($event: any) => (createPhone($event)))
              }, null, 8, ["pwr"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dropd).value = $event)),
            openOn: "addNewEmail"
          }, {
            dropd: _withCtx(() => [
              _createVNode(emailInput, {
                pwr: pwr.value,
                ownerType: "patient",
                onClose: _cache[6] || (_cache[6] = ($event: any) => (dropd.value = '')),
                onCreatePersonEmail: _cache[7] || (_cache[7] = ($event: any) => (createEmail($event)))
              }, null, 8, ["pwr"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dropd).value = $event)),
            openOn: "addNewContact"
          }, {
            dropd: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_list_group, {
                  styles: "pad-s",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (dropd.value = 'addNewFix'))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "phone",
                      styles: "main-m"
                    }),
                    _createVNode(_component_text_item, {
                      txt: "Fixe",
                      class: "mleft-06"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_list_group, {
                  styles: "pad-s",
                  class: "mtop-04",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (dropd.value = 'addNewMobile'))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "mobile",
                      styles: "main-m"
                    }),
                    _createVNode(_component_text_item, {
                      txt: "Mobile",
                      class: "mleft-06"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_list_group, {
                  styles: "pad-s",
                  class: "mtop-04",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (dropd.value = 'addNewEmail'))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "mail",
                      styles: "main-m"
                    }),
                    _createVNode(_component_text_item, {
                      txt: "Email",
                      class: "mleft-06"
                    })
                  ]),
                  _: 1
                }),
                (relativePhones.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "line-h mtop-04" }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relativePhones.value, (pwr, index) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: index,
                          styles: "pad-s",
                          class: "mtop-04",
                          onClick: ($event: any) => (copyPhoneToPwr(pwr.phone))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: `${pwr.lastName.toUpperCase()} ${pwr.firstName}`
                            }, null, 8, ["txt"]),
                            (pwr.link)
                              ? (_openBlock(), _createBlock(_component_text_item, {
                                  key: 0,
                                  txt: ` (${pwr.link})`,
                                  class: "mleft-04"
                                }, null, 8, ["txt"]))
                              : _createCommentVNode("", true),
                            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "mleft-10" }, null, -1)),
                            _createVNode(_component_text_item, {
                              txt: `${pwr.phone.phoneNumber}`,
                              styles: "main-m",
                              style: {"margin-left":"auto"}
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ], 64))
                  : _createCommentVNode("", true),
                (relativeEmails.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "line-h mtop-04" }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relativeEmails.value, (pwr, index) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: index,
                          styles: "pad-s",
                          class: "mtop-04",
                          onClick: ($event: any) => (copyEmailToPwr(pwr.email))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: `${pwr.lastName.toUpperCase()} ${pwr.firstName}`
                            }, null, 8, ["txt"]),
                            (pwr.link)
                              ? (_openBlock(), _createBlock(_component_text_item, {
                                  key: 0,
                                  txt: ` (${pwr.link})`,
                                  class: "mleft-04"
                                }, null, 8, ["txt"]))
                              : _createCommentVNode("", true),
                            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mleft-10" }, null, -1)),
                            _createVNode(_component_text_item, {
                              txt: `${pwr.email.email}`,
                              styles: "main-m",
                              style: {"margin-left":"auto"}
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_button_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "plus",
                    styles: "main-m"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedPhones.value, (phone, indexPhone) => {
            return (_openBlock(), _createBlock(_component_dropdownBox, {
              key: indexPhone,
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((dropd).value = $event)),
              openOn: 'input-phone-' + indexPhone,
              class: "cursor-action"
            }, {
              dropd: _withCtx(() => [
                _createVNode(phoneInput, {
                  "is-update": true,
                  pwr: pwr.value,
                  ref_for: true,
                  ref: 'input-phone-' + indexPhone,
                  phone: phone,
                  onClose: _cache[13] || (_cache[13] = ($event: any) => (dropd.value = '')),
                  ownerType: "patient",
                  onUpdatePersonPhone: ($event: any) => (updatePhone($event, phone.personPhoneId)),
                  onDeletePersonPhone: ($event: any) => (deletePhone(phone.personPhoneId))
                }, null, 8, ["pwr", "phone", "onUpdatePersonPhone", "onDeletePersonPhone"])
              ]),
              default: _withCtx(() => [
                _createVNode(EsDataCard, {
                  title: phone.isMobile ? _unref(t)('patient.admin.mobile') : _unref(t)('patient.admin.phone'),
                  icon: phone.isMobile ? 'iphone-gen2' : 'phone_fill',
                  folderIcon: 'shareIcons',
                  ref_for: true,
                  ref: 'phone-' + indexPhone,
                  backgroundClass: "bg-blue-04",
                  onIconClick: ($event: any) => (callNumber(phone.phoneNumber, phone.phonePrefix))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      (_unref(Regex).number.test(phone.phonePrefix) && _unref(PHONE_PREFIX_LIST).find(item => item.prefix === phone.phonePrefix))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getFlagEmojiForPrefix)(phone.phonePrefix) + ' +' + _unref(PHONE_PREFIX_LIST).find(item => item.prefix === phone.phonePrefix).prefix), 1),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(contact(phone.phoneNumber)), 1)
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_unref(PHONE_PREFIX_LIST).find(item => item.isoCode === phone.phonePrefix))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(getFlagEmojiForCountry)(phone.phonePrefix) + ' +' + _unref(PHONE_PREFIX_LIST).find(item => item.isoCode === phone.phonePrefix).prefix), 1),
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(contact(phone.phoneNumber)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64)),
                      (phone.note)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_text_item, {
                              txt: phone.note,
                              class: "txt-grey-64"
                            }, null, 8, ["txt"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["title", "icon", "onIconClick"])
              ]),
              _: 2
            }, 1032, ["modelValue", "openOn"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedMails.value, (mail, indexMail) => {
            return (_openBlock(), _createBlock(_component_dropdownBox, {
              key: indexMail,
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((dropd).value = $event)),
              openOn: 'input-mail-' + indexMail,
              class: "cursor-action"
            }, {
              dropd: _withCtx(() => [
                _createVNode(emailInput, {
                  "is-update": true,
                  pwr: pwr.value,
                  ref_for: true,
                  ref: 'input-mail-' + indexMail,
                  ownerType: "patient",
                  email: mail,
                  onClose: _cache[15] || (_cache[15] = ($event: any) => (dropd.value = '')),
                  onUpdatePersonEmail: ($event: any) => (updateEmail($event, mail.personEmailId)),
                  onDeletePersonEmail: ($event: any) => (deleteEmail(mail.personEmailId))
                }, null, 8, ["pwr", "email", "onUpdatePersonEmail", "onDeletePersonEmail"])
              ]),
              default: _withCtx(() => [
                _createVNode(EsDataCard, {
                  title: _unref(t)('patient.admin.email'),
                  icon: 'envelope_fill',
                  folderIcon: 'shareIcons',
                  ref_for: true,
                  ref: 'mail-' + indexMail,
                  backgroundClass: "bg-blue-04",
                  onIconClick: ($event: any) => (sendEmail(mail.email))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_text_item, {
                        txt: mail.email,
                        class: "pleft-30px txt-grey-64"
                      }, null, 8, ["txt"]),
                      (mail.note)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_text_item, {
                              txt: mail.note,
                              class: "txt-grey-64"
                            }, null, 8, ["txt"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["title", "onIconClick"])
              ]),
              _: 2
            }, 1032, ["modelValue", "openOn"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.admin.subsubtitle.address'),
            class: "h5"
          }, null, 8, ["txt"]),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((dropd).value = $event)),
            openOn: "addNewAddress"
          }, {
            dropd: _withCtx(() => [
              _createVNode(addressInput, {
                pwr: pwr.value,
                onClose: _cache[17] || (_cache[17] = ($event: any) => (dropd.value = '')),
                "owner-type": "patient",
                onCreatePersonAddress: _cache[18] || (_cache[18] = ($event: any) => (createAddress($event)))
              }, null, 8, ["pwr"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((dropd).value = $event)),
            openOn: "addNewAddressOrRelatives"
          }, {
            dropd: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_list_group, {
                  styles: "pad-s",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (dropd.value = 'addNewAddress'))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "mapPin",
                      styles: "main-m"
                    }),
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.admin.address'),
                      class: "mleft-06"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                }),
                (relativeAddresses.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "line-h mtop-04" }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relativeAddresses.value, (pwr, index) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: index,
                          styles: "pad-s",
                          class: "mtop-04",
                          onClick: ($event: any) => (copyAddressToPwr(pwr.address))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: `${pwr.lastName.toUpperCase()} ${pwr.firstName}`
                            }, null, 8, ["txt"]),
                            (pwr.link)
                              ? (_openBlock(), _createBlock(_component_text_item, {
                                  key: 0,
                                  txt: ` (${pwr.link})`,
                                  class: "mleft-04"
                                }, null, 8, ["txt"]))
                              : _createCommentVNode("", true),
                            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "mleft-10" }, null, -1)),
                            _createVNode(_component_text_item, {
                              txt: `${pwr.address.street} ${pwr.address.locality}`,
                              styles: "main-m",
                              style: {"margin-left":"auto"}
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_button_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "plus",
                    styles: "main-m"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedAddresses.value, (address, indexAddress) => {
            return (_openBlock(), _createBlock(_component_dropdownBox, {
              key: indexAddress,
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((dropd).value = $event)),
              openOn: 'input-address-' + indexAddress,
              class: "cursor-action"
            }, {
              dropd: _withCtx(() => [
                _createVNode(addressInput, {
                  "is-update": true,
                  pwr: pwr.value,
                  ref_for: true,
                  ref: 'input-address-' + indexAddress,
                  address: address,
                  onClose: _cache[22] || (_cache[22] = ($event: any) => (dropd.value = '')),
                  "owner-type": "patient",
                  onUpdatePersonAddress: ($event: any) => (updateAddress($event, address.personAddressId)),
                  onDeletePersonAddress: ($event: any) => (deleteAddress(address.personAddressId))
                }, null, 8, ["pwr", "address", "onUpdatePersonAddress", "onDeletePersonAddress"])
              ]),
              default: _withCtx(() => [
                _createVNode(EsDataCard, {
                  title: _unref(t)('patient.admin.address'),
                  icon: 'house_fill',
                  folderIcon: 'shareIcons',
                  ref_for: true,
                  ref: 'address-' + indexAddress,
                  backgroundClass: "bg-blue-04",
                  onIconClick: ($event: any) => (openMap(address))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_text_item, {
                        txt: address.street,
                        class: "txt-grey-64"
                      }, null, 8, ["txt"]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_text_item, {
                          txt: address.postalCodePrefix + address.postalCode,
                          class: "txt-grey-64"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          txt: address.locality,
                          class: "txt-grey-64"
                        }, null, 8, ["txt"])
                      ]),
                      _createVNode(_component_text_item, {
                        txt: address.country,
                        class: "txt-grey-64"
                      }, null, 8, ["txt"]),
                      (address.note)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createVNode(_component_text_item, {
                              txt: address.note,
                              class: "txt-grey-64"
                            }, null, 8, ["txt"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["title", "onIconClick"])
              ]),
              _: 2
            }, 1032, ["modelValue", "openOn"]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})